import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Navbar,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Badge,
} from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import _ from 'lodash';

import { showLatestSystemMessages } from './messages/actions';
import Constants from '../services/Constants';
import { slug, slugInitialLetter } from '../services/SlugService';
import viewParams from './router/ViewParams';

const MainMenu = (props) => {
  const { authState, oktaAuth } = useOktaAuth();

  const [isOpen, setIsOpen] = useState();

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const showMessages = (e) => {
    const rect = e.target.getBoundingClientRect();
    props.showLatestSystemMessages(rect.left, rect.bottom);
  };

  const calculateCSSTabClass = (title) => {
    const titleLengh = title.length;
    if (titleLengh > 60) {
      return 'xxlTab';
    } else if (titleLengh > 32) {
      return 'xlTab';
    } else if (titleLengh > 23) {
      return 'lgTab';
    } else if (titleLengh > 16) {
      return 'md2Tab';
    } else if (titleLengh > 13) {
      return 'md1Tab';
    } else if (titleLengh > 9) {
      return 'smTab';
    } else {
      return 'xsTab';
    }
  };

  // const getTopicsOfInterest = (plans) => {
  //   const defaultTopic = 'research';
  //   if (plans?.length == 0) {
  //     return defaultTopic;
  //   }
  //   const topicsOfInterest = Constants.CLIENT_TYPE[plans[0].clientType];
  //   return topicsOfInterest ? topicsOfInterest : defaultTopic;
  // };

  const renderMenuItem = (title, to, isActive = null) => {
    return (
      <NavItem
        key={title + to}
        className={calculateCSSTabClass(title)}
        id={`MainMenuLink_${title}`}>
        <RouterNavLink to={to} isActive={isActive}>
          {title}
        </RouterNavLink>
      </NavItem>
    );
  };

  const isAdminOfAnyPlan = () => {
    return (
      _.filter(
        props.plans,
        (plan) => plan.planAdministratorEmail === props.user.email
      ).length > 0
    );
  };

  const renderLeftMenu = () => {
    const items = [];

    if (props.showPlans) {
      items.push(renderMenuItem('Portfolios', '/portfolios', null));
      if (isAdminOfAnyPlan()) {
        items.push(renderMenuItem('Admin', '/admin', null));
      }
      if (props.skyanAccess || props.isEmployee) {
        items.push(renderMenuItem('SKYAN', '/skyan', null));
      }
      if (props.isEmployee === true) {
        items.push(
          renderMenuItem('Consulting Resources', '/consultingResources', null)
        );
      }
    }

    const {
      viewParams: { plan },
      // plans,
    } = props;

    // const topic = plan ? Constants.CLIENT_TYPE[plan.clientType] : getTopicsOfInterest(plans);
    const topic = 'research'; // just research topics for now

    items.push(renderMenuItem('Videos', '/videos/' + topic, null));
    items.push(renderMenuItem('Blog', '/blog', null));

    if (plan) {
      const { planName, clientName, accessMyManager } = plan;
      const planNameSlug = slug(planName);
      const letterSlug = slugInitialLetter(clientName);
      const page = accessMyManager ? 'manager' : 'client';
      items.push(
        renderMenuItem(
          plan.planName,
          `/portfolio/${letterSlug}/${planNameSlug}/${page}`,
          () => true
        )
      );
    }

    return (
      <Navbar light className="leftMenu">
        <Nav>{items}</Nav>
      </Navbar>
    );
  };

  const logout = async () => await oktaAuth.signOut();

  const renderRightMenu = () => {
    const { documentsView } = props.viewParams;
    const messagesActive = documentsView === Constants.HUB_SETTINGS_VIEW;
    const myProfile = props.isClient
      ? renderMenuItem('My Profile', '/profile')
      : null;
    const { seenMessages, latest: allMessages } = props;
    const unreadAnnouncements = _.filter(
      allMessages,
      (message) => !_.includes(seenMessages, message.id)
    ).length;
    const unreadBadge =
      unreadAnnouncements > 0 ? (
        <sup>
          <Badge color="danger" className="announcementsBadge">
            {unreadAnnouncements}
          </Badge>
        </sup>
      ) : null;
    return (
      <Navbar light expand="lg">
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav navbar>
            {myProfile}
            <NavItem className="md1Tab" id={`MainMenuLink_Announcements`}>
              <NavLink onClick={showMessages} active={messagesActive}>
                Announcements {unreadBadge}
              </NavLink>
            </NavItem>
            <NavItem className="xsTab" id="sign-out-button">
              <NavLink onClick={logout}>Sign Out</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    );
  };

  return <div className="mainMenu">
    {authState?.isAuthenticated
      ? (
        <>
          {renderLeftMenu()}
          {renderRightMenu()}
        </>
      )
      : null
    }
  </div>;
};

MainMenu.propTypes = {
  isClient: PropTypes.bool,
  isEmployee: PropTypes.bool,
  showLatestSystemMessages: PropTypes.func.isRequired,
  selectedView: PropTypes.string,
  showPlans: PropTypes.bool.isRequired,
  user: PropTypes.object,
  auth: PropTypes.object,
  seenMessages: PropTypes.array.isRequired,
  latest: PropTypes.array.isRequired,
  skyanAccess: PropTypes.bool,
  viewParams,
  plans: PropTypes.array,
};

const checkShowPlans = (state) => {
  const {
    resources: {
      plans: { data: plans },
    },
  } = state;
  if (plans && plans.length === 1 && plans[0].accessEnabled) {
    return false;
  }
  return true;
};

const mapStateToProps = (state) => {
  return {
    showPlans: checkShowPlans(state),
    isClient: state.okta.isClient,
    user: state.okta.user,
    latest: state.messages.latest || [],
    seenMessages: state.messages.seenMessages || [],
    isEmployee: state.okta.isEmployee,
    skyanAccess: state.resources.skyan_access.data || false,
    plans: state.resources.plans.data || [],
  };
};

export default connect(mapStateToProps, { showLatestSystemMessages })(MainMenu);
